import { FC, useCallback } from 'react';
import { useSelector } from 'react-redux';
import { AdvancedFilterRow, SingleSelectionAdvancedFilter } from 'shared/components/AdvancedFilter';
import { useFilterChangeCallback } from 'shared/hooks';
import { selectFinishingFilter } from 'shared/selectors/advancedFilters/finishing';

export const FinishingContainer: FC = () => {
  const { label, value, options } = useSelector(selectFinishingFilter);

  const onChange = useFilterChangeCallback();

  const handleFinishingChange = useCallback(
    (newValue: boolean | null) => {
      onChange({ action: 'setHasFinishing', arguments: [newValue] });
    },
    [onChange],
  );

  return (
    <AdvancedFilterRow label={label}>
      <SingleSelectionAdvancedFilter options={options} value={value} onFilterChange={handleFinishingChange} />
    </AdvancedFilterRow>
  );
};
